import {activateTotp, enrollEmail} from "../../../services/api/factorApi";
import {runApi} from "../../../services/api/ApiContext";
import {useState} from "react";
import {toast} from "react-toastify";
import GAIcon from "../../../../images/icon_email.png";
import IconUser from "../../../../images/icon_user.png"
import {AuthBack, AuthBox, AuthButton, AuthContent, AuthIcon, AuthIntro} from "../../common/AuthBox";
import {useHistory} from "react-router-dom";
import {useFactors} from "../../../contexts/FactorsContext";
import {CBTextBox} from "../../common/ContentBox";
import {useProfile} from "../../../contexts/ProfileContext";
import IconError from "../../../../images/error.png";

const backToUrl = '/profile/mfa/enroll/OKTA/email';

const maskEmail = (email) => {
	const parts = email.split('@');

	return `${parts[0][0]}...${parts[0][parts[0].length-1]}@${parts[1]}`;
}

const OktaEnrollOktaEmail = () => {
	const history = useHistory();
	const {data} = useProfile();
	const {refresh} = useFactors();
	const [enrollStep, setEnrollStep] = useState(1);
	const [passCode, setPassCode] = useState(null);
	const [factorId, setFactorId] = useState(null);
	const [reSendCode, setReSendCode] = useState(null);

	const email = data?.primaryEmail;

	if(!email) {
		toast.error('Cannot find email, are you logged in?');
		history.push('/');
		return;
	}

	const enroll = async () => {
		setReSendCode(false);

		const enrollOktaEmailResponse = await runApi(
			'enrollOktaEmail',
			() => enrollEmail(email)
		);

		if (!enrollOktaEmailResponse?.data?.status) {
			return;
		}

		setEnrollStep(3);
		startResendCount();

		setFactorId(enrollOktaEmailResponse?.data?.data?.id);
	}

	const startResendCount = () => {
		setTimeout(
			function () {
				setReSendCode(true);
			},
			10000
		);
	}

	const activate = async () => {
		const activateGoogleAuthResponse = await runApi(
			'activiateOktaEmail',
			() => activateTotp(factorId, passCode)
		);

		if (!activateGoogleAuthResponse?.data?.status) {
			return;
		}

		toast.success("Activate OKTA Email successfully.")
		finishActivate();
	}

	const finishActivate = () => {
		refresh();
		history.push('/profile/mfa');
	}

	return (
		<AuthBox>
			<AuthIcon src={enrollStep === 1 ? IconUser : GAIcon}/>

			{enrollStep === 1 && (
				<AuthIntro
					Title={'Email Authentication'}
					Description={'Enter a verification code sent to your email.'}
					Icon={GAIcon}
					nextEvent={() => setEnrollStep(2)}
				/>
			)}

			{enrollStep === 2 && (
				<AuthContent>
					<p><strong>Set up Email Authentication</strong></p>

					<p>Send a verification code to your registered email.</p>

					<div className="google-authenticator clearfix">
						<AuthButton buttonEvent={() => enroll()} buttonText={"Send me the code"}/>
					</div>

					<AuthBack src={backToUrl} />
				</AuthContent>
			)}

			{enrollStep === 3 && (
				<AuthContent>
					<p><strong>Set up Email Authentication</strong></p>

					<p>A verification code was sent to <span className={'mask-email'}>{maskEmail(email)}</span>. Check your email and enter the code below.</p>

					{reSendCode && (
						<div className="infobox-warning clearfix">
							<span className="error-icon"><img src={IconError} alt="error" width="16"/></span>
							<p>Haven't received an email? To try again, <span className={'resend-email-btn'} onClick={() => enroll()}>Send again</span></p>
						</div>
					)}

					<form className="enter-code">
						<label>Verification code</label>
						<CBTextBox
							disabled={false}
							value={passCode}
							onChange={e => setPassCode(e.target.value)}
						/>
					</form>

					<AuthButton buttonEvent={() => activate()} buttonText={"Verify"}/>

					<AuthBack src={backToUrl} />
				</AuthContent>
			)}
		</AuthBox>
	);
};

export default OktaEnrollOktaEmail;
